import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { ANALYTICS_COPY } from '../../constants/analyticsCopy';
import InterveneAgentSelect from './InterveneAgentSelect';
import {
  mergeInterveneAudienceFilters,
  readInterveneAudienceFilters,
} from '../../utils/interveneFilters';

export default function InterveneAudiencePanel({
  filters = [],
  onChange,
  orgId,
  disabled = false,
}) {
  const { agent, agentUserId, customer } = readInterveneAudienceFilters(filters);

  const patchAudience = (patch) => {
    const next = mergeInterveneAudienceFilters(filters, {
      agent: 'agent' in patch ? patch.agent : agent,
      agentUserId: 'agentUserId' in patch ? patch.agentUserId : agentUserId,
      customer,
    });
    onChange(next);
  };

  return (
    <Box
      sx={(theme) => ({
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: alpha(theme.palette.primary.main, 0.03),
        p: 2,
      })}
    >
      <Stack spacing={2}>
        <Box>
          <Typography variant="subtitle2" fontWeight={700}>
            {ANALYTICS_COPY.interveneAudienceTitle}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {ANALYTICS_COPY.interveneAudienceDescription}
          </Typography>
        </Box>

        <InterveneAgentSelect
          orgId={orgId}
          label={ANALYTICS_COPY.interveneAgentFilterLabel}
          placeholder={ANALYTICS_COPY.interveneAgentFilterPlaceholder}
          helperText={ANALYTICS_COPY.interveneAgentFilterHint}
          value={agent}
          onChange={(selection) => patchAudience({
            agent: selection?.username || '',
            agentUserId: selection?.userId || '',
          })}
          disabled={disabled}
        />
      </Stack>
    </Box>
  );
}
